export const enum CinematicEvents {
  DP_VERIFIED_FC_CHECKTOKEN = 'DP_VERIFIED_FC_CHECKTOKEN',
  FC_DATATRANSFER_CONSENT_IDENTITY = 'FC_DATATRANSFER_CONSENT_IDENTITY',
  FC_VERIFIED = 'FC_VERIFIED',
}
